// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Modifier-ApplySetItemModal-__ApplySetItemModal___1c3RT","dialog":"app-pages-Library-Modifier-ApplySetItemModal-__ApplySetItemModal___2LBl4"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Modifier/ApplySetItemModal/ApplySetItemModal.css
// module id = 2184
// module chunks = 0